import { Component, OnInit } from '@angular/core'
import { environment } from '@tv3/environments/environment'
import { AuthService } from '@tv3/services/auth.service'
import { NavigationEnd, RouterEvent, Router } from '@angular/router'
import { filter } from 'rxjs/operators'

interface ACMBannerData {
  path?: RegExp
  image: string
  description: string
  btnText: string
}

@Component({
  selector: 'app-acm-banner',
  templateUrl: './acm-banner.component.html',
  styleUrls: ['./acm-banner.component.scss'],
})
export class AcmBannerComponent implements OnInit {
  banners: ACMBannerData[] = [
    {
      path: /^\/calendar/,
      image: '/assets/images/acm/calendars.webp',
      description:
        'Upgrade to <span class="text-success text-bold">AdvanceCM</span> to manage all your bookings, rates and availability on one page—no more switching tabs!',
      btnText: 'Upgrade for Free Now',
    },
    {
      path: /^\/guests/,
      image: '/assets/images/acm/guests.webp',
      description:
        '<span class="text-success text-bold">AdvanceCM</span> lets you view and manage all your guests and their bookings in one place with better visibility and organization.',
      btnText: 'Try AdvanceCM Today',
    },
    {
      path: /^\/inquiries/,
      image: '/assets/images/acm/inquiries.webp',
      description:
        'Switch to <span class="text-success text-bold">AdvanceCM</span> and manage all your messages from WhatsApp, social media, email, SMS, and OTAs in a unified inbox—keeping guest communication seamless and effortless!',
      btnText: 'Upgrade for Free',
    },
    {
      path: /^\/expenses/,
      image: '/assets/images/acm/expenses.webp',
      description:
        '<span class="text-success text-bold">AdvanceCM</span> automates expense tracking with easy-to-read graphs—take full financial control today!',
      btnText: 'Get Started Free',
    },
    {
      path: /^\/tasks/,
      image: '/assets/images/acm/tasks.webp',
      description:
        'With <span class="text-success text-bold">AdvanceCM</span>, automate task creation, manage checklists, and set up recurring tasks effortlessly. Get instant updates when tasks are created, completed, reassigned, or overdue—eliminate manual work for good!',
      btnText: 'Switch to AdvanceCM',
    },
    {
      path: /^\/reviews/,
      image: '/assets/images/acm/reviews.webp',
      description:
        'Upgrade to <span class="text-success text-bold">AdvanceCM</span> to manage your reviews across Airbnb, Booking.com, Vrbo, and Expedia—all in one dashboard. Get insights and automate Airbnb and Vrbo reviews effortlessly!',
      btnText: 'Manage Reviews Easily',
    },
    {
      path: /^\/dashboard/,
      image: '/assets/images/acm/dashboard.webp',
      description:
        '<span class="text-success text-bold">AdvanceCM\'s</span> improved interface helps you track revenue, bookings, and business performance seamlessly.',
      btnText: 'Upgrade Now for Free',
    },
    {
      path: /^\/rates/,
      image: '/assets/images/acm/rates.webp',
      description:
        '<span class="text-success text-bold">AdvanceCM</span> automates rates with dynamic pricing, channel adjustments, minimum night stay rules, and optimization for last-minute bookings and gap nights—helping you maximize earnings!',
      btnText: 'Set Smart Rates Now',
    },
    {
      path: /^\/rentals/,
      image: '/assets/images/acm/rentals.webp',
      description:
        'Switch to <span class="text-success text-bold">AdvanceCM</span> to optimize multi-unit property management with parent-child rental setups—streamline availability and maximize efficiency',
      btnText: 'Manage Rentals Smarter',
    },
    {
      path: /^\/channels/,
      image: '/assets/images/acm/channels.webp',
      description:
        'Connect to your preferred channels effortlessly with <span class="text-success text-bold">AdvanceCM\'s</span> new streamlined connection wizards. Get a clearer overview of all your connected listings and manage them with ease!',
      btnText: 'Upgrade for Free',
    },
    {
      path: /^\/automations/,
      image: '/assets/images/acm/automations.webp',
      description:
        'The <span class="text-success text-bold">Revolutionary Autopilot</span> is here! 🚀 Take your automations to the next level with AdvanceCM—streamline guest communication, invoicing, and more, so you can focus on growing your rental business effortlessly!',
      btnText: 'Upgrade to AdvanceCM Free',
    },
  ]

  genericBanner: ACMBannerData = {
    image: '/assets/images/acm/rocket.webp',
    description:
      'Shift to <span class="text-success text-bold">AdvanceCM</span> for free! Get better automation, smarter tools, and an enhanced booking experience today!',
    btnText: 'Upgrade to AdvanceCM Free',
  }

  currentBanner: ACMBannerData = this.genericBanner

  pageNavigationEnd$ = this.router.events.pipe(filter((event: RouterEvent) => event instanceof NavigationEnd))

  constructor(private router: Router, private authService: AuthService) {}

  ngOnInit(): void {
    this.pageNavigationEnd$.subscribe((s) => {
      this.currentBanner = this.banners.find((b) => b.path?.test(s.url)) || this.genericBanner
    })
  }

  get acmAppUrl() {
    return `${environment.acmAppUrl}/login?token=${this.authService.token}&redirectURL=${location.pathname}`
  }
}
